export type RoleLicense = {
  id: string;
  name: string;
};
